import localStorage from "local-storage-fallback";

export function setWithExpiry(key: string, value: any, ttl: number) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key: string) {
  const itemString = localStorage.getItem(key);
  if (!itemString) return null;

  let item;
  try {
    item = JSON.parse(itemString);
  } catch {
    // Corrupted value — treat as absent and clean it up.
    localStorage.removeItem(key);
    return null;
  }

  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}
